import { CollapsablePanel as IsbjCollapsablePanel, CollapsablePanelDetails, CollapsablePanelHeader, Spinner } from '@isbj-redesign/frontend-components'
import React, { FC, useState } from 'react'
import ArrowIcon from './ArrowIcon'
import classes from './Spinner.module.css'

export type BaseCollapsablePanelProps = {
    title: string
    loading?: boolean
}

export type CollapsablePanelProps = BaseCollapsablePanelProps & {
    collapsed: boolean
    setCollapsed(collapsed: boolean): void
}

export const CollapsablePanel: FC<CollapsablePanelProps> = ({ title, collapsed, setCollapsed, children, loading }) => (
    <IsbjCollapsablePanel collapsed={collapsed} onToggle={setCollapsed} className="bg-white border shadow my-3">
        <CollapsablePanelHeader title={title} headingLevel={2} className="p-3 d-flex align-items-center" style={{ fontSize: '1rem' }}>
            <ArrowIcon direction={collapsed ? 'right' : 'bottom'} className="mr-2" />
            <strong>{title}</strong> {loading && <Spinner className={`${classes.spinner} ml-2`} />}
        </CollapsablePanelHeader>
        <CollapsablePanelDetails className="m-3">{children}</CollapsablePanelDetails>
    </IsbjCollapsablePanel>
)

export type UncontrolledCollapsablePanelProps = BaseCollapsablePanelProps & { initiallyCollapsed?: boolean }

export const UncontrolledCollapsablePanel: FC<UncontrolledCollapsablePanelProps> = ({ initiallyCollapsed, ...props }) => {
    const [collapsed, setCollapsed] = useState(initiallyCollapsed || false)
    return <CollapsablePanel collapsed={collapsed} setCollapsed={setCollapsed} {...props} />
}
